


// import React, { useState } from 'react';
// import { NavLink } from 'react-router-dom';
// import { Wallet, Gift, Home, Headphones, User } from 'lucide-react';
// // import './BottonMenu.css';

// const BottonMenu = () => {
//   const [clickedTab, setClickedTab] = useState(null);

//   const handleTabClick = (tabName) => {
//     setClickedTab(tabName);
//     setTimeout(() => {
//       setClickedTab(null);
//     }, 600); // Reset animation state
//   };

//   return (
//     <div className="bottom_nav_wrapper">
//       <div className="bottom_nav_bar">
        
//         {/* 1. WALLET TAB */}
//         <NavLink
//           exact
//           to="/wallet"
//           className={`nav_item ${clickedTab === 'wallet' ? 'animate_wallet' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('wallet')}
//         >
//           <div className="nav_icon_wrapper">
//             <Wallet className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Wallet</span>
//         </NavLink>

//         {/* 2. REFER TAB */}
//         <NavLink
//           exact
//           to="/refer"
//           className={`nav_item ${clickedTab === 'refer' ? 'animate_bounce' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('refer')}
//         >
//           <div className="nav_icon_wrapper">
//             <Gift className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Refer</span>
//         </NavLink>

//         {/* 3. CENTER HOME BUTTON */}
//         <div className="center_fab_container">
//           <NavLink
//             exact
//             to="/landing"
//             className="center_fab_button"
//             activeClassName="active_center"
//             onClick={() => handleTabClick('home')}
//           >
//             <div className="fab_pulse_aura"></div>
//             <Home className="center_icon" size={24} />
//           </NavLink>
//         </div>

//         {/* 4. SUPPORT TAB */}
//         <NavLink
//           exact
//           to="/support"
//           className={`nav_item ${clickedTab === 'support' ? 'animate_bounce' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('support')}
//         >
//           <div className="nav_icon_wrapper">
//             <Headphones className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Support</span>
//         </NavLink>

//         {/* 5. PROFILE TAB */}
//         <NavLink
//           exact
//           to="/Profile"
//           className={`nav_item ${clickedTab === 'profile' ? 'animate_bounce' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('profile')}
//         >
//           <div className="nav_icon_wrapper">
//             <User className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Profile</span>
//         </NavLink>

//       </div>
//     </div>
//   );
// };

// export default BottonMenu;

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Wallet, Gift, Home, Headphones, User } from 'lucide-react';

const BottonMenu = () => {
  const [clickedTab, setClickedTab] = useState(null);

  const handleTabClick = (tabName) => {
    setClickedTab(tabName);
    setTimeout(() => {
      setClickedTab(null);
    }, 600);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      padding: '0 16px 20px 16px',
      pointerEvents: 'none'
    }}>
      <div style={{
        pointerEvents: 'auto',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        maxWidth: '460px',
        background: 'rgba(11, 15, 25, 0.95)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid rgb(175 36 112 / 94%)',
        borderRadius: '24px',
        padding: '10px 14px',
        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.8), inset 0 1px 0 rgba(255, 255, 255, 0.15)',
        position: 'relative'
      }}>
        
        {/* Helper style definitions for active/hover states with high visibility */}
        <style>{`
          .custom-nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            color: #94a3b8;
            flex: 1;
            padding: 4px 0;
            transition: all 0.3s ease;
            position: relative;
          }
          .custom-nav-item:hover {
            color: #c7d2fe;
          }
          .custom-nav-item.active-nav {
            color: #818cf8;
          }
          .custom-nav-item.active-nav .icon-box {
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.25) 0%, rgba(168, 85, 247, 0.25) 100%);
            border-color: rgba(99, 102, 241, 0.6);
            color: #ffffff;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
          }
          .custom-nav-item.active-nav .nav-text {
            color: #ffffff !important;
            font-weight: 700;
          }
          .custom-nav-item.active-nav .active-indicator {
            transform: scaleX(1);
            opacity: 1;
          }
        `}</style>

        {/* 1. WALLET TAB */}
        <NavLink
          exact
          to="/wallet"
          className="custom-nav-item"
          activeClassName="active-nav"
          onClick={() => handleTabClick('wallet')}
        >
          <div className="icon-box" style={{
            width: '40px',
            height: '40px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(2, 6, 23, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            color: '#94a3b8',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}>
            <Wallet size={20} />
          </div>
          <span className="nav-text" style={{ fontSize: '11px', fontWeight: 600, marginTop: '4px', color: '#94a3b8', letterSpacing: '0.3px', transition: 'all 0.3s' }}>Wallet</span>
          <span className="active-indicator" style={{ position: 'absolute', bottom: '-2px', width: '16px', height: '2px', background: '#818cf8', borderRadius: '2px', transform: 'scaleX(0)', opacity: 0, transition: 'all 0.3s' }}></span>
        </NavLink>

        {/* 2. REFER TAB */}
        <NavLink
          exact
          to="/refer"
          className="custom-nav-item"
          activeClassName="active-nav"
          onClick={() => handleTabClick('refer')}
        >
          <div className="icon-box" style={{
            width: '40px',
            height: '40px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(2, 6, 23, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            color: '#94a3b8',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}>
            <Gift size={20} />
          </div>
          <span className="nav-text" style={{ fontSize: '11px', fontWeight: 600, marginTop: '4px', color: '#94a3b8', letterSpacing: '0.3px', transition: 'all 0.3s' }}>Refer</span>
          <span className="active-indicator" style={{ position: 'absolute', bottom: '-2px', width: '16px', height: '2px', background: '#818cf8', borderRadius: '2px', transform: 'scaleX(0)', opacity: 0, transition: 'all 0.3s' }}></span>
        </NavLink>

        {/* 3. CENTER HOME FAB BUTTON */}
        <div style={{ flex: '1', display: 'flex', justifyContent: 'center', position: 'relative' }}>
          <NavLink
            exact
            to="/landing"
            activeClassName="active-fab-nav"
            onClick={() => handleTabClick('home')}
            style={{
              position: 'absolute',
              top: '-26px',
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#ffffff',
              boxShadow: '0 10px 30px rgba(99, 102, 241, 0.6), 0 0 0 5px rgba(11, 15, 25, 1)',
              textDecoration: 'none',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
            }}
          >
            <div style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              border: '1px solid rgba(255, 255, 255, 0.5)',
            }}></div>
            <Home size={24} />
          </NavLink>
        </div>

        {/* 4. SUPPORT TAB */}
        <NavLink
          exact
          to="/support"
          className="custom-nav-item"
          activeClassName="active-nav"
          onClick={() => handleTabClick('support')}
        >
          <div className="icon-box" style={{
            width: '40px',
            height: '40px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(2, 6, 23, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            color: '#94a3b8',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}>
            <Headphones size={20} />
          </div>
          <span className="nav-text" style={{ fontSize: '11px', fontWeight: 600, marginTop: '4px', color: '#94a3b8', letterSpacing: '0.3px', transition: 'all 0.3s' }}>Support</span>
          <span className="active-indicator" style={{ position: 'absolute', bottom: '-2px', width: '16px', height: '2px', background: '#818cf8', borderRadius: '2px', transform: 'scaleX(0)', opacity: 0, transition: 'all 0.3s' }}></span>
        </NavLink>

        {/* 5. PROFILE TAB */}
        <NavLink
          exact
          to="/Profile"
          className="custom-nav-item"
          activeClassName="active-nav"
          onClick={() => handleTabClick('profile')}
        >
          <div className="icon-box" style={{
            width: '40px',
            height: '40px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(2, 6, 23, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            color: '#94a3b8',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}>
            <User size={20} />
          </div>
          <span className="nav-text" style={{ fontSize: '11px', fontWeight: 600, marginTop: '4px', color: '#94a3b8', letterSpacing: '0.3px', transition: 'all 0.3s' }}>Profile</span>
          <span className="active-indicator" style={{ position: 'absolute', bottom: '-2px', width: '16px', height: '2px', background: '#818cf8', borderRadius: '2px', transform: 'scaleX(0)', opacity: 0, transition: 'all 0.3s' }}></span>
        </NavLink>

      </div>
    </div>
  );
};

export default BottonMenu;